import React, { useContext, useEffect, useState } from "react";
import "./Festival_Products.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { popularCategory, Products } from "../../../utils/apis/Product/Product";
import { Context } from "../../../utils/context";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { SeasonalBanners } from "../../../utils/apis/master/Master";

const Festival_Products = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
  const [banner, setBanner] = useState(null);
  const navigate = useNavigate();

  const getBanner = async () => {
    setShimmerLoader(true);
    const res = await SeasonalBanners();
    console.log(res, "res res");

    if (res?.success) {
      // API has only ONE banner
      setBanner(res?.data);
    } else {
      setBanner(null);
    }

    setShimmerLoader(false);
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="Festival_Products">
      <div className="banner_holder">
        <div>
          <img
            src={IMG_URL + banner?.banner?.image}
            alt="Banner"
            className="banner_img"
          />
        </div>
      </div>

      {/* <div className="banner_holder">
        <img
          src={IMG_URL + products?.[0]?.banner_image}
          className="banner_img"
        />
      </div> */}

      <div className="swiper_holder">
        <Swiper
          spaceBetween={20}
          // pagination={{ dynamicBullets: true, clickable: true }}
          modules={[Autoplay, Pagination, Navigation]}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          slidesPerView={5}
          // loop={seasonalCategories.length > 1}
          className="festival-main-swiper mySwiper"
          breakpoints={{
            0: { slidesPerView: 2 },
            420: { slidesPerView: 3},
            485: { slidesPerView: 3 },
            768: { slidesPerView: 4},
            992: { slidesPerView: 4},
            1023: { slidesPerView: 5 },
            1200: { slidesPerView: 5.5 },

            1300: { slidesPerView: 5.5 },

            1400: { slidesPerView: 5 },

            1600: { slidesPerView: 5 },
          }}
        >
          {banner?.category?.map((val, index) => {
            return (
              <SwiperSlide key={index}>
                <div
                  className="card_holder"
                  onClick={() => {
                    navigate(`/shop?category_id=${val?.id}`);
                  }}
                >
                  <div className="bg_img_holder">
                    <img
                      src="/assets/Image/Homepage/festival/card_bg.png"
                      className="bg_img"
                    />
                  </div>

                  <div className="content_div">
                    <p className="product_name">{val?.name}</p>
                    <div className="img_holder">
                      <img src={IMG_URL + val?.image} className="inner_img" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Festival_Products;

// import React, { useContext, useEffect, useState } from "react";
// import "./Festival_Products.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import { useNavigate } from "react-router-dom";
// import { popularCategory } from "../../../utils/apis/Product/Product";
// import { Context } from "../../../utils/context";
// import { Autoplay, Pagination, Navigation } from "swiper/modules";

// const Festival_Products = () => {
//   const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
//   const [seasonalCategories, setSeasonalCategories] = useState([]);
//   const navigate = useNavigate();

//   const getProduct = async () => {
//     setShimmerLoader(true);
//     const res = await popularCategory();

//     if (res?.success) {
//       const seasonal = res?.data?.filter(
//         (item) => item?.seasonal_status === 1 && item?.status === 1
//       );
//       setSeasonalCategories(seasonal);
//       setShimmerLoader(false);
//     }
//   };

//   useEffect(() => {
//     getProduct();
//   }, []);

//   return (
//     <section className="Festival_Products">
//       {shimmerLoader ? (
//         <div>Loading seasonal products...</div>
//       ) : seasonalCategories.length === 0 ? (
//         <div>No seasonal categories available</div>
//       ) : (
//         <Swiper
//           spaceBetween={30}
//           pagination={{ dynamicBullets: true, clickable: true }}
//           modules={[Autoplay, Pagination, Navigation]}
//           autoplay={{ delay: 4000, disableOnInteraction: false }}
//           loop={seasonalCategories.length > 1}
//           className="festival-main-swiper"
//         >
//           {seasonalCategories.map((category) => (
//             <SwiperSlide key={category.id}>
//               <div className="festival-slide">
//                 {/* Banner Image */}
//                 {category.banner_image ? (
//                   <div className="banner_holder">
//                     <img
//                       src={IMG_URL + category.banner_image}
//                       alt={category.name}
//                       className="banner_img"
//                       onError={(e) => (e.target.style.display = "none")}
//                     />
//                   </div>
//                 ) : (
//                   <div className="banner_placeholder">
//                     {category.name} - Seasonal Collection
//                   </div>
//                 )}

//                 {/* Subcategories for THIS category only */}
//                 {category.sub_categories &&
//                   category.sub_categories.length > 0 ? (
//                   <div className="swiper_holder">
//                     <Swiper
//                       spaceBetween={15}
//                       slidesPerView={2.5}
//                       breakpoints={{
//                         480: { slidesPerView: 3 },
//                         768: { slidesPerView: 4 },
//                         992: { slidesPerView: 5 },
//                         1200: { slidesPerView: 6 },
//                       }}
//                       pagination={{ clickable: true }}
//                       modules={[Pagination]}
//                       className="subcategory-swiper"
//                     >
//                       {category.sub_categories.map((sub) => (
//                         <SwiperSlide key={sub.id}>
//                           <div
//                             className="card_holder"
//                             onClick={() =>
//                               // navigate(
//                               //   `/shop?category=${category.id}&subcategory=${sub.id}`
//                               // )
//                               navigate(
//                                 `/shop?category_id=${category.id}&sub_category_id=${sub.id}&category_image=${category.image}`
//                               )
//                             }
//                             style={{ cursor: "pointer" }}
//                           >
//                             <div className="bg_img_holder">
//                               <img
//                                 src="/assets/Image/Homepage/festival/card_bg.png"
//                                 alt="bg"
//                                 className="bg_img"
//                               />
//                             </div>
//                             <div className="content_div">
//                               <p className="product_name">{sub.name}</p>
//                               <div className="img_holder">
//                                 <img
//                                   src={IMG_URL + sub.image}
//                                   alt={sub.name}
//                                   className="inner_img"
//                                   onError={(e) =>
//                                   (e.target.src =
//                                     "/assets/Image/placeholder.jpg")
//                                   }
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </SwiperSlide>
//                       ))}
//                     </Swiper>
//                   </div>
//                 ) : (
//                   <div className="no-subcategory-text">
//                     {/* Explore {category.name} Collection Soon! */}
//                   </div>
//                 )}
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       )}
//     </section>
//   );
// };

// export default Festival_Products;

// import React, { useContext, useEffect, useState } from "react";
// import "./Festival_Products.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import { useNavigate } from "react-router-dom";
// import { popularCategory } from "../../../utils/apis/Product/Product";
// import { Context } from "../../../utils/context";
// import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import { SeasonalBanners } from "../../../utils/apis/master/Master";
// const Festival_Products = () => {
//   const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
//   const [banner, setBanner] = useState(null);
//   const navigate = useNavigate();

// const getBanner = async () => {
//   setShimmerLoader(true);
//   const res = await SeasonalBanners();
//   console.log("banner",banner)
//   if (res?.success && res?.data?.length > 0) {
//     // API has only ONE banner
//     setBanner(res.data[0]);
//   } else {
//     setBanner(null);
//   }

//   setShimmerLoader(false);
// };

// useEffect(() => {
//   getBanner();
// }, []);

//   return (
//     <section className="Festival_Products">
//       {shimmerLoader ? (
//         <div>Loading seasonal banner...</div>
//       ) : !banner ? (
//         <div>No seasonal banner available</div>
//       ) : (
//         <div className="festival-single-banner">
//           {/* Banner Image */}
//           <div className="banner_holder">
//             <img
//               src={IMG_URL + banner?.image}
//               alt="Seasonal Banner"
//               className="banner_img"
//               onError={(e) => (e.target.style.display = "none")}
//             />
//           </div>

//           {/* Optional CTA */}
//           {banner?.category_id && (
//             <div className="banner-action">
//               <button
//                 className="explore-btn"
//                 onClick={() =>
//                   navigate(`/shop?category_id=${banner.category_id}`)
//                 }
//               >
//                 Explore Collection
//               </button>
//             </div>
//           )}
//         </div>
//       )}
//     </section>
//   );
// };

// export default Festival_Products;
